import React from "react";
import Road from "../../Road";
import { RoadComponentProps } from "../types";

export const RoadComponent: React.FC<RoadComponentProps> = ({
  isExpense,
  showTime,
  roads,
  rights,
  changeRoads,
  changeRoadMode,
  multiRoadMode,
  isTabIndexDisabled,
}) => {

  return (
    <div
      className={`box-modal-form-block`}
    >
      <Road
        defaultOptions={roads}
        isReadOnly={isExpense && !rights?.travel}
        onChange={changeRoads}
		showTime={showTime}
        onChangeRoadMode={changeRoadMode}
        multiRoadMode={multiRoadMode}
        isAdvance={!isExpense}
        tabIndex={isTabIndexDisabled ? -1 : 0}
      />
    </div>
  );
};
